
import { Component, Vue, Prop } from "vue-property-decorator";
import { EmployeeDataType } from "../../data-management/data-sources/sources/employees-data-source";
import { Gui } from "../../gui/gui";
import { SelectUserCommandParameters } from "../../gui/commands/select-user-command-executor";
import { ContextDetailComponent } from "../../gui/components/context-detail/context-detail-component";
import EmployeeProfileImage from "./EmployeeProfileImage.vue";
import axios from "axios";
import * as moment from "moment";
import store from "@/store/store";

@Component({
  components: {
    EmployeeProfileImage
  }
})
export default class EmployeeCard extends Vue {
  private selected: boolean = false;

  @Prop()
  person: EmployeeDataType;
  @Prop()
  scrollEventListener: (callBackFunction: () => void) => void;

  mounted() {
    if (
      store.state.commandManager.selectUserCommandExecutor.previousOptions &&
      store.state.commandManager.selectUserCommandExecutor.previousOptions
        .userId === this.person._internal_datasource_id_
    ) {
      this.handleSelected();
    }

    store.state.commandManager.selectUserCommandExecutor.commandExecuted.attach(
      (parameters: SelectUserCommandParameters) => {
        if (this.person._internal_datasource_id_ === parameters.userId) {
          this.handleSelected();
        } else {
          this.selected = false;
        }
      }
    );
  }

  private handleSelected() {
    this.selected = true;
    // wait for old card to collapse before emitting scroll position
    this.$nextTick(() => this.$emit("select", (this.$el as HTMLElement).offsetTop));
  }

  private select() {
    store.state.commandManager.selectUserCommandExecutor.requestExecute({
      userId: this.person._internal_datasource_id_
    });
  }

  private isNewHire(person: EmployeeDataType): boolean {
    const newHireThresholdDate = moment().subtract(3, "months");
    const startDate = moment(person.StartDate);
    return (
      newHireThresholdDate.isBefore(startDate, "day") ||
      newHireThresholdDate.isSame(startDate, "day")
    );
  }

  protected openUrlInNewTab(url: string) {
    const tab = window.open(url, "_blank");
    tab.focus();
  }
}
